define('plugin/invoice/view/InvoiceListCollectionView',['require','marionette','plugin/invoice/view/InvoiceListItemView'],function (require) {

    var Marionette = require('marionette');
    var InvoiceListItemView = require('plugin/invoice/view/InvoiceListItemView');

    /**
     * invoice collection view (invoices collection)
     *
     * @class InvoiceListCollectionView
     */
    return Marionette.CollectionView.extend({

        childView: InvoiceListItemView

    });

});
